module.exports = __webpack_public_path__ + "static/04-de69ae3d6b098e0692b4c3105883dabe.jpg";